// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pm-page {
  padding: 24px 28px;
  background: #f7f9fc;
  min-height: calc(100vh - 64px);
}

.pm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.pm-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pm-title h1 {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #172033;
}

.pm-subtitle {
  margin: 6px 0 0;
  color: #667085;
}

.pm-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.pm-tab {
  border: 1px solid #d8e0ea;
  background: #fff;
  color: #344054;
  border-radius: 6px;
  padding: 8px 12px;
  font-weight: 600;
}

.pm-tab.active {
  background: #1f8f98;
  border-color: #1f8f98;
  color: #fff;
}

.pm-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.pm-card {
  background: #fff;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.05);
  padding: 18px;
}

.pm-metric-label {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.pm-metric-value {
  color: #172033;
  font-size: 30px;
  font-weight: 800;
  margin-top: 8px;
}

.pm-toolbar {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.pm-form {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr auto;
  gap: 10px;
  align-items: end;
}

.pm-form.ticket-form {
  grid-template-columns: 2fr 1fr 1fr auto;
}

.pm-form .form-control,
.pm-form .form-select {
  min-height: 40px;
}

.pm-kanban {
  display: grid;
  grid-template-columns: repeat(3, minmax(250px, 1fr));
  gap: 14px;
}

.pm-column {
  background: #f0f4f8;
  border: 1px solid #dbe4ef;
  border-radius: 8px;
  min-height: 360px;
  padding: 12px;
}

.pm-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-weight: 700;
  color: #172033;
}

.pm-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.pm-task {
  background: #fff;
  border: 1px solid #e8edf4;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.pm-task-title {
  color: #172033;
  font-weight: 700;
  margin-bottom: 6px;
}

.pm-task-meta {
  color: #667085;
  font-size: 12px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.pm-task-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.pm-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 820px;
}

.pm-table th {
  background: #f2f5f9;
  color: #667085;
  font-size: 12px;
  text-transform: uppercase;
}

.pm-table th,
.pm-table td {
  padding: 12px;
  border-bottom: 1px solid #edf0f5;
  vertical-align: top;
}

.pm-table-title {
  color: #172033;
  font-weight: 700;
}

.pm-muted {
  color: #667085;
  font-size: 12px;
  margin-top: 4px;
}

.pm-empty {
  color: #667085;
  text-align: center;
  padding: 30px 12px;
}

.pm-metric-card {
  width: 100%;
  text-align: left;
  border-left: 4px solid #1f8f98;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.pm-metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.10);
}

.pm-metric-card:focus-visible {
  outline: 2px solid #1f8f98;
  outline-offset: 2px;
}

.pm-bars {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pm-bar-row {
  display: grid;
  grid-template-columns: 180px 1fr 50px;
  align-items: center;
  gap: 12px;
}

.pm-bar-label {
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pm-bar-track {
  background: #f0f4f8;
  border-radius: 4px;
  height: 18px;
  overflow: hidden;
}

.pm-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease;
}

.pm-bar-count {
  color: #172033;
  font-weight: 700;
  text-align: right;
}

@media (max-width: 720px) {
  .pm-bar-row {
    grid-template-columns: 120px 1fr 40px;
  }
}

@media (max-width: 1180px) {
  .pm-page {
    padding: 20px 18px;
  }

  .pm-grid,
  .pm-kanban {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pm-form,
  .pm-form.ticket-form {
    grid-template-columns: 1fr 1fr;
  }

  .pm-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .pm-toolbar > * {
    min-width: 0;
  }
}

@media (max-width: 720px) {
  .pm-page {
    padding: 18px 14px;
  }

  .pm-header {
    flex-direction: column;
  }

  .pm-grid,
  .pm-kanban,
  .pm-form,
  .pm-form.ticket-form {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProjectManagement/ProjectManagement.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF","sourcesContent":[".pm-page {\n  padding: 24px 28px;\n  background: #f7f9fc;\n  min-height: calc(100vh - 64px);\n}\n\n.pm-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.pm-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pm-title h1 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #172033;\n}\n\n.pm-subtitle {\n  margin: 6px 0 0;\n  color: #667085;\n}\n\n.pm-tabs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.pm-tab {\n  border: 1px solid #d8e0ea;\n  background: #fff;\n  color: #344054;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-weight: 600;\n}\n\n.pm-tab.active {\n  background: #1f8f98;\n  border-color: #1f8f98;\n  color: #fff;\n}\n\n.pm-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.pm-card {\n  background: #fff;\n  border: 1px solid #edf0f5;\n  border-radius: 8px;\n  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.05);\n  padding: 18px;\n}\n\n.pm-metric-label {\n  color: #667085;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.pm-metric-value {\n  color: #172033;\n  font-size: 30px;\n  font-weight: 800;\n  margin-top: 8px;\n}\n\n.pm-toolbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n  flex-wrap: wrap;\n}\n\n.pm-form {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr auto;\n  gap: 10px;\n  align-items: end;\n}\n\n.pm-form.ticket-form {\n  grid-template-columns: 2fr 1fr 1fr auto;\n}\n\n.pm-form .form-control,\n.pm-form .form-select {\n  min-height: 40px;\n}\n\n.pm-kanban {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(250px, 1fr));\n  gap: 14px;\n}\n\n.pm-column {\n  background: #f0f4f8;\n  border: 1px solid #dbe4ef;\n  border-radius: 8px;\n  min-height: 360px;\n  padding: 12px;\n}\n\n.pm-column-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  font-weight: 700;\n  color: #172033;\n}\n\n.pm-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.pm-task {\n  background: #fff;\n  border: 1px solid #e8edf4;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 10px;\n}\n\n.pm-task-title {\n  color: #172033;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.pm-task-meta {\n  color: #667085;\n  font-size: 12px;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pm-task-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.pm-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 820px;\n}\n\n.pm-table th {\n  background: #f2f5f9;\n  color: #667085;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.pm-table th,\n.pm-table td {\n  padding: 12px;\n  border-bottom: 1px solid #edf0f5;\n  vertical-align: top;\n}\n\n.pm-table-title {\n  color: #172033;\n  font-weight: 700;\n}\n\n.pm-muted {\n  color: #667085;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.pm-empty {\n  color: #667085;\n  text-align: center;\n  padding: 30px 12px;\n}\n\n.pm-metric-card {\n  width: 100%;\n  text-align: left;\n  border-left: 4px solid #1f8f98;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pm-metric-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.10);\n}\n\n.pm-metric-card:focus-visible {\n  outline: 2px solid #1f8f98;\n  outline-offset: 2px;\n}\n\n.pm-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pm-bar-row {\n  display: grid;\n  grid-template-columns: 180px 1fr 50px;\n  align-items: center;\n  gap: 12px;\n}\n\n.pm-bar-label {\n  color: #344054;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pm-bar-track {\n  background: #f0f4f8;\n  border-radius: 4px;\n  height: 18px;\n  overflow: hidden;\n}\n\n.pm-bar-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.4s ease;\n}\n\n.pm-bar-count {\n  color: #172033;\n  font-weight: 700;\n  text-align: right;\n}\n\n@media (max-width: 720px) {\n  .pm-bar-row {\n    grid-template-columns: 120px 1fr 40px;\n  }\n}\n\n@media (max-width: 1180px) {\n  .pm-page {\n    padding: 20px 18px;\n  }\n\n  .pm-grid,\n  .pm-kanban {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .pm-form,\n  .pm-form.ticket-form {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .pm-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .pm-toolbar > * {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 720px) {\n  .pm-page {\n    padding: 18px 14px;\n  }\n\n  .pm-header {\n    flex-direction: column;\n  }\n\n  .pm-grid,\n  .pm-kanban,\n  .pm-form,\n  .pm-form.ticket-form {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
